




























































































import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { IFilmCategory as ICat } from "@/@types/cinema/film-category";

import ButtonCart from "@/components/buttons/button-cart.vue";
import ButtonBack from "@/components/buttons/button-back.vue";
import draggable from "vuedraggable";
import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";
import MovieCategoryForm from "./movie-category-form.vue";
import BSwitch from "@/components/app/switchs/b-switch.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: {
    StandartModal,
    ButtonCart,
    ButtonBack,
    draggable,
    btn: ChangeDeliteButtons,
    MovieCategoryForm,
    BSwitch,
  },
})
export default class MovieCategorys extends Vue {
  @Prop({ type: Array, default: () => [] }) categorys!: Array<ICat>;
  @Prop({ type: Boolean, default: false }) deletedCat!: boolean;
  @Inject("categoryFolder") readonly folder!: string;

  enabled = true;
  dragging = false;
  cat_id = "";
  img = "";

  get category(): ICat | null {
    const category = this.categorys.find((c) => c._id == this.cat_id);
    return category ? category : null;
  }

  send(): void {
    this.dragging = false;
    this.$emit("updateCategorysSortOrder");
  }

  mustChange(id: string): void {
    this.cat_id = id;
    this.$nextTick(() => this.$bvModal.show("movie-category-form"));
  }

  updateCategory(data: Partial<ICat>, id: string): void {
    this.$emit("updateCategory", data, id);
  }
}
